import { ReactElement } from 'react';
import { useApplicationSupportTabs } from '../../../Hooks/useApplicationSupportTabs';
import { PageLayout } from '../../../Layouts/PageLayout/PageLayout';

export function ApplicationSupportPage(): ReactElement {
  const tabs = useApplicationSupportTabs();
  return <PageLayout tabs={tabs} />;
}
